module.exports = __webpack_public_path__ + "static/media/security-testing.50fc2723.png";